import moment from 'moment';

export default {
    displayFullDateTime(date) {
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const now = moment(new Date());
        const toCompare = moment(date);
        const hoursDiff = now.diff(toCompare, 'hours', false)

        if (hoursDiff === 0) {
            const minutesDiff = now.diff(toCompare, 'minutes', false);

            return `${minutesDiff} min${minutesDiff > 1 ? 's' : ''} ago`;
        } else if (hoursDiff < 24) {
            return `${hoursDiff} hour${hoursDiff > 1 ? 's' : ''} ago`;
        }

        const timeString = moment(date).format('h:mm a');
        return `${date.getDate()} ${months[date.getMonth()]} at ${timeString}`;
    },
}
